import svg from "./scatterplot-candidate-base-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const ScatterplotCandidateBaseIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.candidate.light,
);

export default ScatterplotCandidateBaseIcon;
